export function isAdobeSignOrigin(origin: string): boolean {
  try {
    const { protocol, hostname } = new URL(origin);
    if (protocol !== 'https:') {
      return false;
    }
    return hostname.endsWith('.adobesign.com');
  } catch {
    return false;
  }
}

export function parseAdobeSignMessage(data: unknown): unknown | null {
  if (data && typeof data === 'object') {
    return data;
  }
  if (typeof data !== 'string') {
    return null;
  }
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
}

export function isAdobeSignEsignEvent(payload: unknown): boolean {
  return (
    !!payload &&
    typeof payload === 'object' &&
    (payload as { type?: unknown }).type === 'ESIGN'
  );
}
